import { useAuth } from '@/auth/useAuth'
import { FullPageMessage } from '@/components/FullPageMessage'
import { Button } from '@/components/ui'

/**
 * Where an account lands when it exists but is attached to nothing: someone
 * signed in with a Microsoft account that is not on the admin allowlist, or
 * an invitation expired before it was accepted. Nothing is readable from
 * here, because current_org_id() returns null for an inactive profile.
 */
export function Waiting() {
  const { profile, signOut, refreshProfile } = useAuth()

  return (
    <FullPageMessage
      title="This account is not linked yet"
      body={`${profile?.email ?? 'Your account'} exists, but it is not attached to a partner organisation and does not hold a Ki Tua o Matariki role. The team can link it from the administration screen.`}
    >
      <div className="flex justify-center gap-3">
        <Button onClick={refreshProfile} variant="secondary">Check again</Button>
        <Button onClick={signOut} variant="quiet">Sign out</Button>
      </div>
    </FullPageMessage>
  )
}
